// extracted by mini-css-extract-plugin
export default {"containerNewEditor":"EditorOnePage_containerNewEditor__6lQtQ","newEditor":"EditorOnePage_newEditor__aYNFC","transformComponent":"EditorOnePage_transformComponent__8LOs7"};